module.exports = __webpack_public_path__ + "img/logo-idt.4e5e7c45.png";